export default {
    subscriptionsTitle: 'Subscription requests',
    subscriptionsMenu: 'Subscriptions',
    subscriptionsSubtitle: 'Review and resolve tenant plan change requests',
    subColTenant: 'Tenant',
    subColChange: 'Change',
    subColType: 'Type',
    subColStatus: 'Status',
    subColDate: 'Date',
    subColActions: 'Actions',
    subColNotes: 'Notes',
    typeInitial: 'Initial',
    typeUpgrade: 'Upgrade',
    typeDowngrade: 'Downgrade',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    filterAll: 'All',
    approve: 'Approve',
    reject: 'Reject',
    noRequests: 'There are no subscription requests',
    approveSuccess: 'Request approved and plan updated',
    rejectSuccess: 'Request rejected',
    approveError: 'Error approving the request',
    rejectError: 'Error rejecting the request',
    loadError: 'Error loading the requests',
    confirmReject: 'Do you want to reject this plan change request?',
    conflictsTitle: 'Current usage exceeds the new plan limits',
    conflictsForce: 'Force the downgrade anyway? Incompatible add-ons will be cancelled.',
    noPlan: 'No plan',
};
